/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/ 
import * as i0 from "./chip-notResponsive.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./chip-notResponsive.component";
var styles_ChipNotResponsiveComponent = [i0.styles];
var RenderType_ChipNotResponsiveComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ChipNotResponsiveComponent, data: {} });
export { RenderType_ChipNotResponsiveComponent as RenderType_ChipNotResponsiveComponent };
export function View_ChipNotResponsiveComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_ChipNotResponsiveComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-chip-notResponsive", [], [[2, "active", null]], [[null, "click"]], function (_v, en, $event) { var ad = true; if (("click" === en)) {
        var pd_0 = (i1.ɵnov(_v, 1).onclick($event.target) !== false);
        ad = (pd_0 && ad);
    } return ad; }, View_ChipNotResponsiveComponent_0, RenderType_ChipNotResponsiveComponent)), i1.ɵdid(1, 114688, null, 0, i2.ChipNotResponsiveComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, function (_ck, _v) { var currVal_0 = i1.ɵnov(_v, 1).selected; _ck(_v, 0, 0, currVal_0); }); }
var ChipNotResponsiveComponentNgFactory = i1.ɵccf("app-chip-notResponsive", i2.ChipNotResponsiveComponent, View_ChipNotResponsiveComponent_Host_0, { selected: "selected" }, { select: "select" }, ["*"]);
export { ChipNotResponsiveComponentNgFactory as ChipNotResponsiveComponentNgFactory };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/chips/chip-notResponsive/chip-notResponsive.component.ngfactory.js.pre-build-optimizer.js